import { useTranslation } from 'react-i18next';
function StarSvg({ children, handleTdClick, symbol, watchlistSymbols }) {
    const { t } = useTranslation();
    const label = watchlistSymbols
      ? t('symbol.removeFromWatchlist', 'Remove from watchlist')
      : t('symbol.addToWatchlist', 'Add to watchlist');
    return (
        <button
            type="button"
            aria-label={`${label}: ${symbol}`}
            aria-pressed={Boolean(watchlistSymbols)}
            onKeyDown={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    event.stopPropagation();
                    event.currentTarget.click();
                }
            }}
            onClick={(event) => {
                event.stopPropagation();
                handleTdClick(symbol);
            }}
            className={`specific-td ${watchlistSymbols ? 'clicked' : ''} star-td`}
            data-tooltip={label}
        >
            <svg
                bool={watchlistSymbols ? 'true' : 'false'}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                aria-hidden="true"
            >
                <path
                    d="M4 1.5h8v13L8 11.35 4 14.5V1.5z"
                    bool={watchlistSymbols ? 'true' : 'false'}
                    strokeWidth="1.35"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
            </svg>
        </button>
    );
}

export default StarSvg;
